var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxNavArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-back-button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Paperless-\\u2013-Digital-reception-\\u2013-v4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a.-Onboarding-\\u2013-expected-photos-\\u2013-bodyshop-flow",
    transform: "translate(-16.000000, -93.000000)",
    fill: "#6B6E85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53454391,0 L0.504539673,5.96712021 C0.220649157,6.24658091 -0.0900518714,6.64782583 0.0243719118,7 C-0.0901338512,7.35173503 0.220511747,7.75328382 0.504539673,8.03287979 L6.53454391,14 L8,12.5574108 L2.38654161,6.99995548 L8,1.44258917 L6.53454391,0 Z",
    id: "px-back-button"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxNavArrowLeft);
export default __webpack_public_path__ + "static/media/px-nav-arrow-left.7135b29978c948d78dddca187c6b11d2.svg";
export { ForwardRef as ReactComponent };